/* TK: drag sideways scrolling rows with a mouse (touch and trackpads scroll them natively).
   Used by the bag drawer's "Don't forget these..." row (snippets/cart-drawer.liquid, styled in assets/custom.css),
   the homepage collection rail (sections/tk-collection-rail.liquid) and the product page's "You may also like" row
   (styled in assets/tk-product.css).
   Event delegation, so rows the drawer re-renders after an add/remove keep working. A drag never opens the product
   under the pointer. */
(function () {
  var ROWS = 'cart-drawer .cart-drawer__recommendations-grid, .tk-crail__track, .template-product .product-recommendations .product-grid--wrapper';
  var drag = null;

  document.addEventListener('pointerdown', function (e) {
    if (e.pointerType !== 'mouse' || e.button !== 0 || !e.target.closest) return;
    var row = e.target.closest(ROWS);
    if (!row || row.scrollWidth <= row.clientWidth) return;
    drag = { row: row, x: e.clientX, left: row.scrollLeft, moved: false };
  });

  document.addEventListener('pointermove', function (e) {
    if (!drag) return;
    var dx = e.clientX - drag.x;
    if (!drag.moved && Math.abs(dx) > 6) { drag.moved = true; drag.row.classList.add('is-dragging'); }
    if (drag.moved) drag.row.scrollLeft = drag.left - dx;
  });

  function end() {
    if (!drag) return;
    var d = drag;
    drag = null;
    d.row.classList.remove('is-dragging');
    if (d.moved) {
      var stop = function (ev) { ev.preventDefault(); ev.stopPropagation(); };
      d.row.addEventListener('click', stop, { capture: true, once: true });
      setTimeout(function () { d.row.removeEventListener('click', stop, true); }, 0);
    }
  }
  document.addEventListener('pointerup', end);
  document.addEventListener('pointercancel', end);
  document.addEventListener('dragstart', function (e) {
    if (e.target.closest && e.target.closest(ROWS)) e.preventDefault();
  });
})();
